module.exports = __webpack_public_path__ + "static/backhand_left_emoji-b06772d5bd3c42b0382b48f1388cba5b.svg";